import {
  SET_RESULTS,
  UPDATE_SEARCH_TERM,
  SET_SEARCH_TERM_ERRORS,
  SET_SEARCH_LOADING,
  CLEAR_RESULTS,
  SET_MORE_RESULTS,
} from './actions';

export const documentSearch = (state = {}, action) => {
  switch (action.type) {

    case SET_RESULTS:
      return Object.assign({}, state, {
          page: action.page,
          searchLoading: action.searchLoading
        }
      );
    case SET_MORE_RESULTS:
      return {
        ...state,
        page: action.page
      };

    case CLEAR_RESULTS:
      let clone = Object.assign({}, state);
      delete clone['page'];
      return clone;
    case SET_SEARCH_LOADING:
      return Object.assign({}, state, {
        searchLoading: action.searchLoading
      });
    case UPDATE_SEARCH_TERM:

      return {
        ...state,
        searchTerm: action.searchTerm,
        pageNumber: action.pageNumber,
        errors:[],
        globalErrors:[]
      }

    case SET_SEARCH_TERM_ERRORS:
      return {
        ...state,
        errors: action.validationError.errors,
        globalErrors: action.validationError.messages
      }

    default:
      return state;
  }
};